/* eslint-disable import/no-extraneous-dependencies */
import { Avatar } from '@mantine/core';
import Markdown from 'markdown-to-jsx';
import styles from './comment-thread.module.css';
import { dayjs } from '../../../../utils/dayjs-utils';
import TickIcon from '../../../../assets/icons/TickIcon';

interface Comment {
  _id: string;
  profile_pic: string | null;
  name: string;
  createdAt: Date;
  editedAt: Date;
  isEdited: boolean;
  comment: string;
  isResolved: boolean;
}

interface CommentThreadProps {
  comments: Comment[];
  isLoading: boolean;
}

export default function CommentThread({ comments, isLoading }: CommentThreadProps) {
  if (isLoading) {
    return <div className={styles.loading}>Loading comments...</div>;
  }

  if (!comments?.length) {
    return <div className={styles.noComments}>No comments yet</div>;
  }

  return (
    <div className={styles.commentThread}>
      {comments.map((comment) => (
        <div key={comment._id} className={styles.commentItem}>
          <div className={styles.commentHeader}>
            <Avatar src={comment.profile_pic} alt={comment.name} radius="xl" size={24} />
            <div className={styles.commentMeta}>
              <span className={styles.commentAuthor}>{comment.name}</span>
              <span className={styles.commentTime}>
                {comment.isEdited && 'Edited'} {dayjs(comment.createdAt).fromNow()}
                {comment.isResolved && (
                  <div className={styles.resolvedBadge}>
                    <TickIcon width={12} height={12} color="var(--icon-success)" /> Resolved
                  </div>
                )}
              </span>
            </div>
          </div>
          <div className={`${styles.commentBody} ${comment.isResolved ? styles.resolved : ''}`}>
            <Markdown>{comment.comment}</Markdown>
          </div>
        </div>
      ))}
    </div>
  );
}
